module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-8-5da7023ad0b06b5f37ddd0ff30aefc8f.jpg";